import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = false
window.Stimulus = application

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MarqueeController from "./marquee_controller"
application.register("marquee", MarqueeController)

import HeroController from "./hero_controller"
application.register("hero", HeroController)

import WatchCarouselController from "./watch_carousel_controller"
application.register("watch-carousel", WatchCarouselController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import WavesController from "./waves_controller"
application.register("waves", WavesController)
